module.exports = __webpack_public_path__ + "img/scene4-10.53f6d989.jpg";